import { WaterAlertOutlineIcon } from './WaterAlertOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 4741B9A5-3E15-45B5-BD7B-B812C7E7644F
 * name water-alert-outline
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/water-alert-outline.svg
 * tags
 * - Alert / Error 
 * - Agriculture 
 */
export const InkAlertOutlineIcon = WaterAlertOutlineIcon;
export default InkAlertOutlineIcon